import { useMemo } from 'react';
import { getSportTypeConfig } from '../sports/configs';
import { RunnerCard } from '../components/SelectionCards/RunnerCard';
import { TeamCard } from '../components/SelectionCards/TeamCard';
import { useSweep } from './useSweep';

const selectionCardsBySportType = {
    racing: RunnerCard,
    football: TeamCard
};

// eslint-disable-next-line import/prefer-default-export
export const useSportConfig = () => {
    const { sweep } = useSweep();
    const { sportType } = sweep;

    // Memoize the entire return object to avoid re-creating it on every render
    // Only recalculates when sportType changes, preventing unnecessary re-renders in consuming components
    return useMemo(() => {
        const config = getSportTypeConfig(sportType);

        return {
            sportType,
            config,
            SelectionCard: selectionCardsBySportType[sportType],
            mapSelectionToCardProps: config.mapSelectionToCardProps
        };
    }, [sportType]);
};
